<!--
 * @Description:  Item
-->
<template>
    <div 
        class="item" 
        :class="{ checked: showCheckbox && item.checked }"
        :draggable="draggable"
        @click="itemFun(item)" 
        @dragstart="$emit('dragstart')"
        @dragover.prevent
        @drop="$emit('drop')"
    >
        <el-checkbox v-if="showCheckbox" class="item_checkbox" v-model="item.checked" @click.native.stop></el-checkbox>
        <div class="img_view">
            <div
                class="img"
                :style="{
                    backgroundImage: `url(${item.image || item.templateImage})`,
                }"
            >
                <img class="tag" src="@i/camp/mgmt/physical_icon.svg" alt />
                <div class="head_img">
                    <cl-avatar class="img" :src="item.creatorAvatar" :round="true" width="24" height="24"></cl-avatar>
                </div>
            </div>
        </div>
        <div class="info">
            <p class="text">{{ item.templateName || item.title }}</p>
        </div>
        <p class="item_bottom_line" v-if="showCheckbox"></p>
    </div>
</template>

<script>
    export default {
        name: 'cl-template-card',
        components: {},
        props: {
            item: {
                type: Object,
                default: () => {
                    return {}
                },
            },
            showCheckbox: {
                type: Boolean,
                default: false,
            },
			// 能否拖动
			draggable: {
				type: Boolean,
				default: false,
			}
        },
        data() {
            return {}
        },
        computed: {},
        methods: {
            // 点击
            itemFun(item) {
                this.$emit('click', item)
            },
        },
        mounted() {},
        beforeDestroy() {},
    }
</script>

<style scoped lang="scss">
    * {
        box-sizing: border-box;
    }
    .item {
        position: relative;
        // overflow: hidden;
        width: 210px;
        height: 180px;
        background: #ffffff;
        box-shadow: 0px 16px 16px rgba(129, 129, 138, 0.08);
        border-radius: 4px;
        cursor: pointer;
        &.checked {
            .item_bottom_line {
                display: block;
            }
            * {
                opacity: 0.5;
            }
            .item_checkbox,
            .item_bottom_line {
                opacity: 1;
            }
        }
        .item_checkbox {
            position: absolute;
            top: -4px;
            right: -4px;
        }
        .img_view {
            position: relative;
            width: 210px;
            height: 119px;
            .img {
                position: relative;
                overflow: hidden;
                width: 100%;
                height: 100%;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                .tag {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    width: 22px;
                    height: 22px;
                }
                .head_img {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 42px;
                    height: 42px;
                    background: url(~@i/exercise/creator-bg.svg) top center no-repeat;
                    background-size: cover;
                    .img {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                    }
                }
            }
        }
        .info {
            padding: 12px 10px;
            .text {
                overflow: hidden;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                color: #3a3a3a;
            }
        }
        .item_bottom_line {
            position: absolute;
            bottom: -1px;
            left: 50%;
            transform: translateX(-50%);
            display: none;
            width: 210px;
            height: 3px;
            border-radius: 6px 6px 0 0;
            background: $base-color-theme;
        }
    }
</style>
